import { ChangeDetectorRef, Component, Input, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import { AppIcons } from '../../../../shared/app.icons';
import { AppSettings } from '../../../../shared/app.settings';
import { MITableComponent } from '../../../../shared/components/mi-table/mi-table.component';
import type { Column } from '../../../../shared/models/attribute.models';
import type { Country } from '../../../../shared/models/country';
import type { EntityList } from '../../../../shared/models/entity.models';
import type { Language } from '../../../../shared/models/language';
import type { Values } from '../../../../shared/models/listResponse.models';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { ConfigService } from '../../../../shared/services/config.service';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
@Component({
  selector: 'app-activity-feed',
  templateUrl: './activity-feed.component.html',
  styleUrl: './activity-feed.component.scss',
  standalone: true,
  imports: [TabViewModule, TranslateModule, MITableComponent, BreadcrumbModule, AccessProviderDirective]
})
export class ActivityFeedComponent implements OnInit {
  @ViewChild(MITableComponent) tableRef: MITableComponent;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns = [];
  cols = [];
  @Input() moduleName: string;
  value: number = 50;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels = {};
  attributeLabelsData: any = {};
  filterAttributeLabels: any;
  labelData = {
    attributeLabels: [
      { labelKey: 'manage_users_grid.fields.Status.label', labelValue: 'Status' },
      { labelKey: 'manage_users_grid.fields.UserRole.label', labelValue: 'User Role' }
    ]
  };
  listColumns: Values;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityData: any = {
    actionStatus: "",
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    status: 'both',

  };
  routePath: MenuItem[] = [];
  home: MenuItem = {};
  isModal: boolean = false;
  selectedColumns!: Column[];
  attributeData: any;
  data;
  rowItems: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  columnsData;
  bulkDeleteLabel: string = this.cs.getLabel('manage_users.delete');
  bulkUpdateLabel: string = this.cs.getLabel('manage_users.lbl_update_user');
  bulkUpdateHeader: any;
  reviewHeader: any;
  entityNameToDisplay: any;
  btnUpdate: any;
  deleteRoleHeaderMsg: string;
  deleteRoleMsg: string;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  filterFieldsArray: any[];
  isEntity: boolean = true;
  entityName;
  currentRow;
  filterList;
  entityDataForRole: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: '',
    actionStatus: '',
    status: 'both',
  };
  miIcons = AppIcons;
  userArray: any = [];
  trialId: string;

  constructor(
    private router: Router,
    private cs: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private configService: ConfigService,
    private cd: ChangeDetectorRef,
    private permissionAccessService: PermissionAccessService,
    private entityService: EntityService,
    private loaderService: LoaderService,
    private restApiService: RestApiService,
    private metaDataService: MetaDataService,
    private userService: UserManagementService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(param => {
      this.trialId = param?.id
    });
    this.setUpRoutePath();
    this.setUpRowItems();
    this.setupBulkSelectionsItems();
    this.initializeOtherVariablesAndAPI();
  }


  getMetaData() {
    const payload = this.getMultiApiPayload();
    this.metaDataService.metaDataMultipleApi(payload).subscribe((res) => {
      const advancedFilter = JSON.parse(res.advancedFilter.responseBody);
      this.setSiteFilterView(advancedFilter);

      const sort = JSON.parse(res.sort.responseBody);
      const defaultTableView = JSON.parse(res.defaultTableView.responseBody);
      if (defaultTableView) {
        this.setActivityFeedView(defaultTableView);
      }
      this.cs.applyFilterToColumn(defaultTableView, sort)
      this.getData();

    });
  }
  setSiteFilterView(advancedFilter) {
    this.filterAttributeLabels = this.cs.getAttributeLabels(advancedFilter);
    this.filterList = this.cs.getColumns(advancedFilter);
    this.filterList = _.sortBy(this.filterList, 'attributeIndex');

  }

  setActivityFeedView(res) {
    this.isLoading = false;
    this.data = res;
    this.attributeLabels = this.cs.getAttributeLabels(this.data);
    this.allColumns = this.cs.getColumns(this.data);
    this.allColumns?.forEach((key, index) => {
      this.allColumns[index] = key;
      this.allColumns[index].field = key.attributeCode;
      this.allColumns[index].header = this.cs.getLabelValue(
        `protocol_activity` + `.fields.${key.attributeCode}.label`,
        this.attributeLabels,
        key.attributeCode
      );
    });
    this.filterAvailableColumns = _.clone(this.allColumns);
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_ACTIVITY}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.ADVANCED_FILTER,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_ACTIVITY}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_SORT_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.SORT,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_ACTIVITY}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.DEFAULT_TABLE_VIEW,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
    ]
  }

  initializeOtherVariablesAndAPI() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    localStorage.setItem(AppSettings.COUNTRY, '[{"forTenantCode":null,"countryCode":"AU","countryName":"India","active":true,"countryId":"2","tenantId":"2"}]')
    this.btnLabel = this.cs.getLabel('manage_users.lbl_create_new');
    this.bulkDeleteLabel = this.cs.getLabel('manage_users.message.delete_user');
    this.bulkUpdateLabel = this.cs.getLabel('manage_users.lbl_update_user');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));

    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.bulkUpdateHeader = this.cs.getLabel('manage_users.lbl_bulk_update_header');
    this.entityNameToDisplay = this.cs.getLabel('manage_users.lbl_entity_name_display');
    this.btnUpdate = this.cs.getLabel('manage_users.btn_bulk_update');
    this.reviewHeader = this.cs.getLabel('manage_users.lbl_review_users');
    this.deleteRoleMsg = this.cs.getLabel('manage_users.message.confirm_delete_msg');
    this.deleteRoleHeaderMsg = this.cs.getLabel('manage_users.message.delete_user');
    this.getBulkUpdateAttributeData();
    this.getMetaData();
  }

  private setUpRoutePath() {
    this.routePath = [
      { label: this.cs.getLabel('manage_users.lbl_route_path') },
    ];
  }

  private setUpRowItems() {
    const isEdit = this.permissionAccessService.hasAccess('USER_MANAGEMENT', 'MANAGE_USERS', 'DETAILS', 'EDIT');
    const isUpdateStatus = this.permissionAccessService.hasAccess('USER_MANAGEMENT', 'MANAGE_USERS', 'DETAILS', 'UPDATE_STATUS');
    this.rowItems = [
      ...(isEdit ? [{
        label: this.cs.getLabel('manage_users.edit'),
        icon: `${AppIcons.EDIT_2} wh-122`,
        iconClass: 'bulk-update-icon',
        command: () => {
          this.update();
        }
      }] : []),
      ...(isUpdateStatus ? [{
        label: this.cs.getLabel('manage_users.lbl_make_user_inactive'),
        icon: `${AppIcons.OVERDUE} wh-16 bg-red-500`,
        iconClass: "bulk-update-icon",
        visible: true,
        command: () => {
          this.makeUserActiveInactive(this.currentRow);
        },
      }] : []),
    ];
  }

  private setupBulkSelectionsItems() {
    const isBulkAction = this.permissionAccessService.hasAccess('USER_MANAGEMENT', 'MANAGE_USERS', 'DETAILS', 'BULK_ACTION');
    this.bulkSelectionsItems = [
      ...(isBulkAction ? [{
        label: this.bulkUpdateLabel,
        icon: `${AppIcons.EDIT_2} wh-122`,
        iconClass: 'bulk-update-icon',
        styleClass: 'bulk-update-list',
        command: (e) => {
          if (e.item.label === this.bulkUpdateLabel) {
            this.openBulkUpdateDialog();
          }
        },
      }] : []),
      ...(isBulkAction ? [{
        label: this.bulkDeleteLabel,
        icon: `${AppIcons.BASIC_TRAY} wh-122`,
        iconClass: 'bulk-update-icon',
        styleClass: 'bulk-update-list',
        command: () => {
          this.tableRef.delete(AppSettings.DELETE_TYPE.BULK);
        },
      }] : []),
    ];
  }

  private openBulkUpdateDialog() {
    this.visible = true;
    this.showBulkUpdateDialog = false;
    setTimeout(() => {
      this.showBulkUpdateDialog = true;
      this.tableRef.showBulkRowDialog();
    }, 200);
  }

  getFilterView() {
    this.filterAttributeLabels = this.cs.getAttributeLabels(this.labelData)

  }

  getBulkUpdateAttributeData() {
    this.attributeData = {
      tabs: [
        {
          groups: [
            {
              fields: [
                {
                  attributeCode: 'user_status',
                  attributeValue: 'Status',
                  isDisable: false,
                  presetValues: [
                    { labelValue: 'Active', labelKey: 'Active' },
                    { labelValue: 'Inactive', labelKey: 'Inactive' },
                  ]
                }
              ]
            }
          ]
        }
      ]
    };
    this.updateFilterFieldsArray(this.attributeData.tabs[0]?.groups[0]?.fields);
  }

  private updateFilterFieldsArray(fields: any[]) {
    if (!fields) return;

    this.filterFieldsArray = [];
    fields.forEach(field => {
      if (field.attributeCode === 'user_status') {
        this.filterFieldsArray.push(field)
      }
    });
  }

  getTableView() {
    this.isLoading = false;
    this.searchEntity();

    this.filterAvailableColumns = _.clone(this.allColumns);
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView(),
      filterViewDate: this.getFilterView(),
    })
  }

  getUsers() {
    this.tableData = [];
    this.entityData.countryCode = this.country[0].countryCode;
    this.entityData.limit = 200;
    this.userService.searchEntityUser(this.entityData).subscribe((res: any) => {
      res.data.forEach(user => {
        this.userArray.push({
          id: user.userId,
          actionTaken: `By ${user.firstName} ${user.lastName}`,
          role: user.roles[0].roleName
        })
      })
      this.searchEntity();
    });
  }

  searchEntity() {
    this.tableData = [];
    this.entityData.countryCode = this.country[0].countryCode;
    this.entityData.limit = AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT;
    this.entityData.filters = [{
      attributeId: this.filterList.find(field => field.attributeCode === 'protocol_entity_id')?.attributeId,
      attributeValue: this.trialId
    }]

    this.entityService.searchEntity(AppSettings.ENTITY_CODE.PROTOCOL_ACTIVITY, this.entityData, false).subscribe((res: any) => {
      this.listColumns = res?.data[0]?.values;
      this.pagination = res?.pagination;
      this.totalRecords = res?.count;
      const updatedByIDs = Array.from(new Set((res.data || []).map(ele => ele.values?.updated_by).filter(id => !!id)));
      if (updatedByIDs && updatedByIDs.length > 0) {
        this.entityService.getUserDetailsById(updatedByIDs).subscribe((response: any) => {
          this.userArray = response;
          res.data?.forEach(data => {
            this.userArray.forEach(ele => {
              if (ele.userId === data.values?.updated_by) {
                data.actionUserDetails = {
                  id: ele.userId,
                  actionTaken: `By ${ele.firstName} ${ele.lastName}`,
                  role: ele.rolelist[0].roleName,
                };
              }
            });
            this.tableData.push({
              id: data.id,
              actionUserDetails: data.actionUserDetails,
              ...data.values,
            });
          });
        });
      } else {
        res.data?.forEach(data => {
          this.tableData.push({
            id: data.id,
            actionUserDetails: data.actionUserDetails,
            ...data.values,
          });
        });
      }
      this.loaderService.hide();
    });
  }

  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  onFilterValueChange(event) {
    if (event.Status && event.Status.length === 2 && event.Status.includes('Active') && event.Status.includes('Inactive')) {
      this.entityData.status = 'both';
    } else {
      this.entityData.status = event.Status?.toString() ? event.Status.toString() : 'both';
    }

    if (event?.UserRole !== undefined && event.UserRole?.length > 0) {
      this.entityData.roleName = event.UserRole.map(role => `${role}`);
    } else {
      delete this.entityData.roleName;
    }

    this.entityData.offset = event.first;
    this.searchEntity();
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event) {
    this.entityData.limit = event;
    this.searchEntity();
  }

  update() {
    this.onUpdateUser(this.currentRow.userId);
  }

  onUpdateUser(userId) {
    this.router.navigate(['app/manage-users/edit-user'], { queryParams: { id: userId } });
  }

  makeUserActiveInactive(currentRow) {
    const isActive = currentRow.active === AppSettings.USERS_STATUS.ACTIVE;
    const headerMsg = isActive ? this.cs.getLabel('manage_users.inactive_user_header_message') : this.cs.getLabel('manage_users.active_user_header_message');
    const bodyMsg = isActive ? this.cs.getLabel('manage_users.inactive_status_message') : this.cs.getLabel('manage_users.active_status_message')
    const acceptLabel = isActive ? this.cs.getLabel('manage_users.lbl_deactivate') : this.cs.getLabel('manage_users.lbl_activate');
    this.confirmationService.confirm({
      header: headerMsg,
      message: bodyMsg,
      acceptLabel,
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectLabel: this.cs.getLabel('manage_users.cancel'),
      rejectButtonStyleClass: 'bg-white text-color',
      acceptButtonStyleClass: isActive ? 'bg-red-500' : 'bg-green-500',
      accept: () => {
        this.tableRef.changeStatusOfEntity();
      },
      reject: () => {
      }
    });

  }

  setCurrentRowData(event) {
    this.currentRow = event;
    if (event.active === AppSettings.USERS_STATUS.INACTIVE) {
      this.rowItems[1].label = this.cs.getLabel('manage_users.lbl_make_user_active'),
        this.rowItems[1].icon = `${AppIcons.OVERDUE} wh-16 bg-green-500`,
        this.cd.detectChanges();
    } else {
      this.rowItems[1].label = this.cs.getLabel('manage_users.lbl_make_user_inactive'),
        this.rowItems[1].icon = `${AppIcons.OVERDUE} wh-16 bg-red-500`,
        this.cd.detectChanges();
    }
    this.setEditOptionDisabledForDeletedRecord(event);
  }

  setEditOptionDisabledForDeletedRecord(data) {
    this.rowItems[0].disabled = data.deleted;
    this.cd.detectChanges();
  }

  onSortData(event) {
    this.entityData.defaultSortColumn = event.attributeId;
    this.entityData.defaultSortType = (event.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }
}


